import * as React from "react";

interface DatasetImageItemProps {
  signedUrl: string;
  loading: boolean;
  setLoading: (arg: boolean) => void;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export const DatasetImageItem: React.FC<DatasetImageItemProps> = ({
  signedUrl,
  loading,
  setLoading,
  onClick,
}) => {
  return (
    <img
      style={{
        width: "100%",
        height: loading ? 0 : "auto",
        opacity: loading ? 0 : 1,
        transition: "opacity 0.5s",
        display: "block",
      }}
      src={signedUrl}
      alt={""}
      loading="lazy"
      onLoad={() => setLoading(false)}
      onClick={onClick}
    />
  );
};
